exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.empty-data {\n\tcolor: rgba(6, 38, 62, 0.74);\n\tfont-size: 0.875rem;\n}\n.my-project .nav-tabs {\n\tborder-bottom: 0;\n\tmargin-left: -16px;\n\tmargin-right: -16px;\n}\n", ""]);

// exports
